import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/dev/b2c-portal/frontend/apps/web/src/common/ui/components/error/IllustratedErrorMessage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/dev/b2c-portal/frontend/apps/web/src/common/ui/components/layout/ErrorLayout/index.tsx");
;
import(/* webpackMode: "eager" */ "/builds/dev/b2c-portal/node_modules/@mui/material/Box/index.js");
